"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualTabActivator = void 0;
var tslib_1 = require("tslib");
var BaseTabActivator_1 = require("./BaseTabActivator");
/**
 * Manually activated tabs: users activate a tab and display its panel by pressing space or enter
 */
var ManualTabActivator = /** @class */ (function (_super) {
    tslib_1.__extends(ManualTabActivator, _super);
    function ManualTabActivator(tabsWidget) {
        return _super.call(this, tabsWidget) || this;
    }
    ManualTabActivator.prototype.handleKeyDown = function (tabIndex, keyboardEvent) {
        // Check to see if we should focus a tab (but not change which tab panel is being displayed)
        var tabIndexToFocus = this.tabIndexFromKeyDown(tabIndex, keyboardEvent.key);
        if (tabIndexToFocus !== -1) {
            this.tabsWidget.setFocusedIndex(tabIndexToFocus);
            BaseTabActivator_1.BaseTabActivator.preventDefaultAndStopPropagation(keyboardEvent);
            return;
        }
        // Check to see if we should activate a tab (which would display its corresponding tab panel)
        var tabIndexToActivate = this.tabIndexToActivate(keyboardEvent.key);
        if (tabIndexToActivate !== -1) {
            this.tabsWidget.setActiveIndex(tabIndexToActivate);
            BaseTabActivator_1.BaseTabActivator.preventDefaultAndStopPropagation(keyboardEvent);
        }
    };
    ManualTabActivator.prototype.tabIndexToActivate = function (keyValue) {
        switch (keyValue) {
            case 'Enter':
            case ' ':
                return this.tabsWidget.state.focusedIndex;
            default:
                return -1;
        }
    };
    return ManualTabActivator;
}(BaseTabActivator_1.BaseTabActivator));
exports.ManualTabActivator = ManualTabActivator;
//# sourceMappingURL=ManualTabActivator.js.map